// var languageType = require('./languageCommon.js')
require('./languageCommon.js')
var language = localStorage.getItem('language') || 'zh-CN'
require('../home.css');
require('../less/common/searchForm.less');
require('../en.css')
require('./sensorsdata.js')
var preS = require('./preSearch.js');
var preSearch = preS.preSearch
var Config = require('../config/config.js');
var apiPath = Config.env[Config.scheme].apiPath;
var aihuazhuUrl = Config.env[Config.scheme].aihuazhuUrl;

if(language=='zh-CN'){
    $('body').removeClass('en')
}else{
    $('body').addClass('en')
}
$('.language').on('mouseover',function() {
    $(".choicelanguage").show();
}).on('mouseout',function() {
    $(".choicelanguage").hide();
})
$('.choicelanguage a').eq(0).on('click',function(){
    console.log(window.location)
    window.location.href = window.location.origin+window.location.pathname+'?locale=zh-CN'
    localStorage.setItem('language','zh-CN')
    //window.location.reload();
})
$('.choicelanguage a').eq(1).on('click',function(){
    localStorage.setItem('language','USA');
    window.location.href = window.location.origin+window.location.pathname+'?locale=USA'
     //window.location.reload();
})
$('.choicelanguage a').eq(2).on('click',function(){
 localStorage.setItem('language','JP');
window.location.href = window.location.origin+window.location.pathname+'?locale=JP'
     //window.location.reload();
})
$('.choicelanguage a').eq(3).on('click',function(){
   localStorage.setItem('language','KO');
window.location.href = window.location.origin+window.location.pathname+'?locale=KO'
     //window.location.reload();
})
$('.choicelanguage a').eq(4).on('click',function(){
   localStorage.setItem('language','TH');
window.location.href = window.location.origin+window.location.pathname+'?locale=TH'
    //window.location.reload();
})
$('.choicelanguage a').eq(5).on('click',function(){
    localStorage.setItem('language','TH');
 window.location.href = window.location.origin+window.location.pathname+'?locale=YH'
     //window.location.reload();
 })
$('.brand').addClass('select');
$('.reservation').css('color','white');
var flagIndex=0;
$('.reservationCode .close ,.reservationCode .guanbi').on('click',function () {
    $('.reservationCode').fadeOut(300);
    $('.reservation').css('opacity',1);
});


$(".about1").on('mouseover',function() {
    $(".aboutLv").show();
})
$(".about1").on('mouseout',function() {
    $(".aboutLv").hide();
})
$(".brand1").on('mouseover',function() {
    $(".choiceBrand").show();
}).on('mouseout',function() {
    $(".choiceBrand").hide();
})
$('.submitInfo_input_1').on('click',function () {
    $('.select_forJoinUs').slideToggle();
});
$('.select_forJoinUs span').on('click',function () {
    $('.submitInfo_input_joinUs').html($(this).html());
});
var width = document.documentElement.offsetWidth;
if(width > 1920){
    width = 1920;
}
var width1 = $('.simply_container_header').width();
flagIndex=width1-width;

$('.simply_container_header_conainer div').css({width:width});
$('.simply_container_header_conainer').css({width:7*width});
$(window).resize(function () {
  //当浏览器大小变化时
  width1 = $('.simply_container_header').width();
  flagIndex = width1 - width;

});


var step=1;
var $headerContainer=$('.simply_container_header_conainer');
var timer=setInterval(move,4000);
var moveflag = 0;
moveflag = -flagIndex / 2;
$headerContainer.css({ 'left': -width - moveflag});
function move(n) {
  moveflag=-flagIndex/2;
    step++;
    n!=undefined?step=n:null;
    if(step==6){
      $headerContainer.css('left', -width- moveflag);
        step=2;
    }
    $('.simply_banner li').eq(step-1).addClass('simply_banner_select').siblings().removeClass('simply_banner_select');
    if(step==5){
        $('.simply_banner li').eq(0).addClass('simply_banner_select').siblings().removeClass('simply_banner_select');
    }
    $headerContainer.stop(false,true).animate({left:-step*width-moveflag},2500,'linear',function () {

    });
}
$('.simply_container_header').on('mouseover',function () {
    clearInterval(timer);
});
$('.simply_container_header').on('mouseout',function () {
    timer=setInterval(move,3500);
});
$('.simply_banner li').on('click',function () {
    step=$('.simply_banner li').index($(this))+1;
    $('.simply_banner li').eq(step-1).addClass('simply_banner_select').siblings().removeClass('simply_banner_select');
  $headerContainer.stop(false, true).css({ left: -step * width + -moveflag});
});



var $oImgs=$('.flowerBuilding_info_slider div');
function flowerMove(index){
    $oImgs.eq(index).fadeIn(800).siblings().fadeOut(800);
}
$('.flowerBuilding_info_').on('click',function () {
  var width = parseFloat($('.flowerBuilding_info').width())
    var index1=null;
    for(var j=0;j<4;j++){
        var string2='.flowerBuilding_info_'+(j+1);
        if($(string2).css('display')=="none"){
            index1=j;
        }
    }
    var index=$('.flowerBuilding_info_').index($(this));
   if(index1-index==1){
    $('.flowerBuilding_info_').eq(index1).css({left:parseInt($(this).css('left'))+100})
   }else if(index1-index==-1){
    $('.flowerBuilding_info_').eq(index1).css({left:parseInt($(this).css('left'))-100})
   }
        flowerMove(index);
    $(this).hide().siblings().show();
   if(parseFloat($(this).css("left"))>300||isNaN(parseFloat($(this).css("left")))){
    for(var i=0;i<index+1;i++){
        var string='.flowerBuilding_info_'+(i+1);
        $(string).animate({left:100*i},500);
    }
    for(var k=3;k>index;k--){
        var string1='.flowerBuilding_info_'+(k+1);
        $(string1).animate({left:width-100*(4-k)},500);
    }
   }else{
    for(var i=0;i<index+1;i++){
        var string='.flowerBuilding_info_'+(i+1);
        $(string).animate({left:100*i},500);
    }
    for(var k=3;k>=index;k--){
        var string1='.flowerBuilding_info_'+(k+1);
        $(string1).animate({left:width-100*(4-k)},500);
    }
   }

    $('.flowerBuilding_info_big').eq(index).siblings().slideUp();
    setTimeout(function () {
        $('.flowerBuilding_info_big').eq(index).slideDown();
    },800);

});
$("img").on('dragstart',function(){
    return false;
})



$(function(){
    $.ajax({
        url: apiPath+'/api/hotel/brand_hot_cities.json',
        type: 'GET',
        cache: false,
        data: {
            client:'app',
            brandSeries:120
        },
        success: function(res){
            if (res.success) {
                window.hotCityObj = res.data
                destination( 'inland');
            }
        }
    })
    preSearch({
        checkIn:$('input[data-selector="checkIn"]').val(),
        checkOut:$('input[data-selector="checkOut"]').val()
    },clickDestinationCallback,120)
})

// 目的地 弹窗
function destination(key) {
    $('[data-selector="destination"]').destination({
        data: hotCityObj,
        key: key,
        hot: false,
        mapKey: ['ABCD', 'EFGH', 'JKLM', 'NOPQRS', 'TUVWX', 'YZ'],
        clickCallBack: function (obj) {
            clickDestinationCallback(obj)
        }
    });
}

function clickDestinationCallback(obj){
    $('[name="regionId"]').val(obj.id);
    $('[name="regionName"]').val(obj.name);
    $('input[name="regionType"]').val(obj.type);
     destinationInitVal = obj.name;//默认显示的目的地的值
    var timeObj = getTime(obj.id, true, hotCityObj);
    setDatepickInit(timeObj);
    $('input[name="scenic-spot"]').val('');
    $('input[name="descId"]').val('');
}


$(document).on('submit', '[data-selector="search-hotel"]', function () {
    var cityId = $('input[name="regionId"]').val();
    var regionType = $('input[name="regionType"]').val();
    var startDay = $('input[data-selector="checkIn"]').val();
    var endDay = $('input[data-selector="checkOut"]').val();
    window.open(aihuazhuUrl+'/list/' + regionType + '/' + cityId+'?startDay='+startDay+'&endDay='+endDay+'&brand='+120);
    return false;
});




/** WEBPACK FOOTER **
 ** ./src/js/weiLai.js
 **/